import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getJourneyState, loadShowtimeById } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useJourneyContext } from '../../../../../context/journey/hooks/use-journey-context';
import { getSwapSeatAvailabilityStatus } from '../../../../../utils/swap-seats-utils';
import { JourneyActionButtonBase } from '../base';
import { JourneyActionButtonSwapSeatsModal } from './subcomponents/modal';
import { shouldShowSwapSeatsButton } from './utils';
const b = bemClassBuilder('v-journey-action-button-swap-seats');
export const JourneyActionButtonSwapSeats = observer(props => {
    const { displayText, config, assets, events } = props;
    const { iconName, unavailableIconName } = assets, swapSeatPickerAssets = __rest(assets, ["iconName", "unavailableIconName"]);
    const { journey } = useJourneyContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const journeyState = journey ? getJourneyState(journey) : undefined;
    const orderShowtime = journeyState === null || journeyState === void 0 ? void 0 : journeyState.nextOrderShowtime;
    const order = journey === null || journey === void 0 ? void 0 : journey.orders.find(o => o.showtimes.find(showtime => showtime === orderShowtime));
    useEffect(() => {
        if (!orderShowtime)
            return;
        loadShowtimeById(orderShowtime.showtimeId);
    }, [orderShowtime]);
    if (!order || !orderShowtime)
        return null;
    const swapAvailabilityStatus = getSwapSeatAvailabilityStatus(orderShowtime);
    if (!shouldShowSwapSeatsButton(swapAvailabilityStatus))
        return null;
    const { isAvailable } = swapAvailabilityStatus;
    const icon = isAvailable ? iconName : unavailableIconName;
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [_jsx(JourneyActionButtonBase, { className: b.block(), label: displayText.label, onClick: () => setIsModalOpen(true), iconName: icon }), _jsx(JourneyActionButtonSwapSeatsModal, { orderId: order.id, orderShowtime: orderShowtime, assets: swapSeatPickerAssets, displayText: displayText, config: config, events: events, show: isModalOpen, onClose: () => setIsModalOpen(false), isAvailable: isAvailable })] })));
});
JourneyActionButtonSwapSeats.displayName = 'JourneyActionButtonSwapSeats';
